import { render } from "./Dashboard.vue?vue&type=template&id=5fb531f9"
import script from "./Dashboard.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Dashboard.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script